import { PATH_LOGIN,PATH_HOME } from "@/data/pathData";
// import { TOKEN_KEY } from "@/data/constData";
import store from "@/store";

import mixins from "@/mixins/global";

function authMiddleware({ next, router }) {
  if (!mixins.methods.getLoggedUser()) {
    return router.push(PATH_LOGIN);
  } else {
    return next();
  }
}

function guestMiddleware({ next, router }) {
  if (store.getters.accessToken) {
    return router.push(PATH_HOME);
  } else {
    return next();
  }
}


export {
  authMiddleware,
  guestMiddleware,
};
